import React from "react";
import s from "../labReportPdf.module.scss";

const UrineReport = ({ profile, PageBaseLayout, PageFooter }) => {
  const filterTests = (keywords) => {
    return profile.tests.filter((t) =>
      keywords.some((key) =>
        t.testName.toLowerCase().includes(key.toLowerCase()),
      ),
    );
  };

  const macroTests = filterTests([
    "Color",
    "Appearance",
    "Sediment",
    "Reaction",
    "Specific Gravity",
  ]);
  const chemicalTests = filterTests([
    "Sugar",
    "Albumin",
    "Bile Salt",
    "Bile Pigment",
    "Ketone",
  ]);
  const microTests = profile.tests.filter(
    (t) => !macroTests.includes(t) && !chemicalTests.includes(t),
  );

  const RenderSection = ({ title, tests }) => (
    <>
      <tr className={s.sectionHeaderRow}>
        <td
          colSpan="4"
          style={{
            fontWeight: "bold",
            backgroundColor: "#f2f2f2",
            padding: "3px",
          }}
        >
          {title}
        </td>
      </tr>
      {tests.map((t, idx) => (
        <tr key={idx}>
          <td style={{ paddingLeft: "15px" }}>{t.testName}</td>
          <td align="center">{t.value || "-"}</td>
          <td align="center">{t.units || "-"}</td>
          <td align="center">{t.reference_range_details || "N/A"}</td>
        </tr>
      ))}
    </>
  );

  return (
    <div className={s.reportPage} style={{ pageBreakAfter: "always" }}>
      <PageBaseLayout
        showSampleType={true}
        currentSampleType={profile.sampleType}
      />
      <div className={s.testCategoryHeader}>
        {profile.profileName.toUpperCase()}
      </div>

      <table className={s.resultsTable}>
        <thead>
          <tr>
            <th style={{ width: "40%" }}>Test Description</th>
            <th style={{ textAlign: "center" }}>Value(s)</th>
            <th style={{ textAlign: "center" }}>Unit(s)</th>
            <th style={{ textAlign: "center" }}>Reference Range</th>
          </tr>
        </thead>
        <tbody>
          {macroTests.length > 0 && (
            <RenderSection title="MACROSCOPIC" tests={macroTests} />
          )}
          {chemicalTests.length > 0 && (
            <RenderSection title="CHEMICAL" tests={chemicalTests} />
          )}
          {microTests.length > 0 && (
            <RenderSection title="MICROSCOPIC" tests={microTests} />
          )}
        </tbody>
      </table>

      <PageFooter />
    </div>
  );
};

export default UrineReport;
